module.exports = __webpack_public_path__ + "static/media/basketball.442621c6.svg";